import React from "react";
import {FormInputLabel, Group, Input} from "./form-input.styles";

const FormInput = ({label, ...otherProps}) => {
  return (
    <Group>
      {label && (
        <FormInputLabel htmlFor={otherProps.name}>{label}</FormInputLabel>
      )}
      <Input id={otherProps.name} {...otherProps} />
    </Group>
  );
};

export default FormInput;
